import { render } from "./LegoCollapsibleItem.vue?vue&type=template&id=09e4bdfa"
import script from "./LegoCollapsibleItem.vue?vue&type=script&lang=js"
export * from "./LegoCollapsibleItem.vue?vue&type=script&lang=js"

import "./LegoCollapsibleItem.vue?vue&type=style&index=0&id=09e4bdfa&lang=scss"
script.render = render

export default script